require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-muncie-post-office-credit-union-merges-with-ball-state-financial.json") })
        }
      }, "path---articles-muncie-post-office-credit-union-merges-with-ball-state-financial");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-muncie-post-office-credit-union-merges-with-ball-state-financial!./.cache/json/articles-muncie-post-office-credit-union-merges-with-ball-state-financial.json
// module id = 1699
// module chunks = 231608221292675